import {filterDuplicates, Module} from "@intuitionrobotics/ts-common";
import {Unit, UnitBasic} from "@app/ir-q-app-common/types/units";
import {ActivationsModule} from "@modules/ActivationsModule";
import { UnitConfigurationData } from "@app/ir-q-app-common/types/unit-config";

class UnitsManagerModule_Class
    extends Module {

    getUnitBasic = (unitId: string): UnitBasic | undefined => {
        const activation = ActivationsModule.getActivation(unitId);
        if (!activation)
            return;

        const somSerial = activation.som_device_id;
        const tabletSerial = activation.tablet_device_id;
        if (!somSerial || !tabletSerial)
            return;

        return {
            unitId,
            somSerial,
            tabletSerial,
            activation: true,
            pair: false
        }
    }

    isUnitActivation(unitId: string) {
        return !!ActivationsModule.getActivation(unitId);
    }

    getDeviceType = (deviceId: string, unitList: string[]) => {
        return this.getDeviceAndUnit(deviceId, unitList)?.deviceType;
    };

    getDeviceAndUnit = (deviceId: string, unitList: string[]): { deviceType: string, unitId: string } | undefined => {
        for (const unitId of unitList) {
            const activation = ActivationsModule.getActivation(unitId);
            if (!activation)
                continue;

            const somIds = [activation.som_device_id];
            if (somIds.includes(deviceId))
                return {deviceType: "som", unitId};

            const tabletIds = [activation.tablet_device_id];
            if (tabletIds.includes(deviceId))
                return {deviceType: "tablet", unitId};
        }
    };

    getDevicesIdsByUnits(units: Unit[], _devices: string[], giveByShaAndSerial?: boolean) {
        const unitsBasic = units.map(u => UnitsManagerModule.getUnitBasic(u.unitId));
        return filterDuplicates(unitsBasic.reduce((carry: string[], unitBasic, idx) => {
            if (!unitBasic) {
                this.logError("Cannot find identity for unit: " + units[idx].unitId + " product: " + units[idx].product)
                return carry;
            }

            // Only activations are supported now
            if (_devices.includes("som"))
                carry.push(unitBasic.somSerial);

            if (_devices.includes("tablet"))
                carry.push(unitBasic.tabletSerial);

            return carry;
        }, []));
    }

    is3Point0Unit = (unitId: string) => {
        const basic = UnitsManagerModule.getUnitBasic(unitId);
        if (!basic)
            return null;

        return basic.tabletSerial !== "" && this.is3p0Device(basic.tabletSerial, basic);
    }

    is3p0Device = (serial?: string, basic?: UnitBasic) => {
        if (!basic)
            return !!serial?.startsWith("ELQ30");

        if (!basic.tabletSerial || !basic.somSerial)
            return false;

        return basic.tabletSerial.startsWith("ELQ30") || basic.tabletSerial === basic.somSerial;
    }

    isSerialAtRiskForESD(serial?: string) {
        return serial?.startsWith("220");
    }

    isUnifiedVersion(unitData: UnitConfigurationData | undefined) {
        return unitData?._originalVersion?.toLowerCase()?.includes("unified");
    }
}

export const UnitsManagerModule = new UnitsManagerModule_Class("UnitsManagerModule");
